import styled from "styled-components";
import { Input, Tab } from "@material-ui/core";

export const CustomListMenu = styled.div`
    svg {
        font-size: ${globalThis.config.fonts.sizes.xsmall};
    }
`;

export const InfoLabel = styled.div`
    padding: 1rem 0rem 0rem 1rem;
`;

export const SelectedLabel = styled.span`
    font-size: ${globalThis.config.fonts.sizes.small};
    > span {
        color: ${globalThis.config.colors.gray2};
    }
`;

export const Label = styled.span`
    font-size: ${globalThis.config.fonts.sizes.small};
`;

export const CustomMenuButton = styled.div`
    padding: 0.36rem 0.5625rem;
    border-radius: 0.25rem;
    min-height: 2rem;
    max-height: 2rem;
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    &:hover {
        background-color: ${globalThis.config.colors.gray7};
    }
`;

export const MenuTab = styled(Tab)({
    "&.MuiTab-root": {
        textTransform: "none",
        minWidth: "8.75rem",
        fontSize: "0.7rem",
        fontFamily: globalThis.config.fonts.families.light,
        width: "8.75rem",
        borderRadius: globalThis.config.sizes.borderRadius,
        borderBottom: globalThis.config.border.smallGray7,
    },
});

export const SearchInput = styled(Input)({
    "&.MuiInputBase-root": {
        fontSize: "0.7rem",
        textTransform: "none",
        width: "100%",
        height: "3rem",
        paddingLeft: "1rem",
    },
});

export const MenuButton = styled.div`
    height: 2.5rem;
    border-top: ${globalThis.config.border.small};
    > button.MuiButton-root {
        width: 100%;
        color: ${globalThis.config.colors.black};
        background-color: ${globalThis.config.colors.white};
        font-size: ${globalThis.config.fonts.sizes.small};
        border-radius: 0;
        height: 2.375rem;
        > .MuiButton-label {
            justify-content: start;
        }
        :hover {
            background-color: ${globalThis.config.colors.gray8} !important;
        }
    }
    .MuiButton-contained {
        box-shadow: initial;
    }
    svg {
        margin: 0.188rem 0.688rem;
        margin-left: 0;
    }
`;

export const LoaderWrapper = styled.div`
    text-align: center;
    margin: 2rem 0;
`;

export const StyledBox = styled.div`
    padding: 0rem;
    > ul {
        max-height: 12rem;
        overflow: scroll;
        margin-top: 0.5rem;
        padding-top: 0;
        padding-bottom: 0;

        li {
            font-size: ${(props) => props.fontSize};
            font-family: ${(props) => props.fontFamily};
            padding-right: 0.5rem;
            line-height: 1.5rem;
        }
    }
`;

export const ClearIcon = styled.span`
    font-size: 10px;
    position: absolute;
    padding-left: 2px;
    font-weight: bold;
`;
